import { render, staticRenderFns } from "./clientHome.vue?vue&type=template&id=286e8e07&scoped=true"
import script from "./clientHome.vue?vue&type=script&lang=js"
export * from "./clientHome.vue?vue&type=script&lang=js"
import style0 from "./clientHome.vue?vue&type=style&index=0&id=286e8e07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e8e07",
  null
  
)

export default component.exports